import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { profileModule } from "../../../modules/manage-profile/redux/profile";
import { OnBoardingFounder as ConnectedOnBoardingFounder } from "../../../modules/manage-profile/onboarding-founder";

export const OnBoardingFounder = () => (
  <DynamicModuleLoader modules={[profileModule]}>
    <ConnectedOnBoardingFounder />
  </DynamicModuleLoader>
);
